export default __webpack_public_path__ + "static/media/aqualite.40cc7e09.png";